import { Capacitor } from '@capacitor/core'

// Resolve relative image URLs for Capacitor native app.
// WebView loads from https://localhost, so <img src="/api/...">
// won't reach the real server. Always prepend server origin for
// relative URLs — this is safe on web too (same-origin absolute URL).
const SERVER = 'https://zoya.zozhnik.ru'

// Пути, которые лежат в самом бандле приложения (frontend/public/):
// в нативе они уже грузятся локально, и абсолютизация гоняла бы
// многомегабайтные видео гайдов по сети при каждом открытии статьи.
const BUNDLED_PREFIXES = ['/landing-assets/']

const isBundled = (url) => BUNDLED_PREFIXES.some(p => url.startsWith(p))

// В браузере адрес остаётся относительным — картинку отдаёт тот же сервер,
// что и страницу. Раньше боевой адрес подставлялся всегда, и на staging
// фотографии дневника не открывались: ссылка подписана ключом staging, а
// запрос уходил на прод, где ключ другой (403). Замечено 5.10.2026.
const isNative = Capacitor.isNativePlatform()

export function imgUrl(url) {
  if (!url || typeof url !== 'string') return url
  if (url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url
  if (isBundled(url) || !isNative) return url
  return `${SERVER}${url}`
}

// Для HTML из БД, который уходит в v-html (статьи, энциклопедия, excerpt).
// Вызывать один раз при загрузке данных, а не в шаблоне: регэксп-проход по
// десяткам килобайт HTML на каждый ре-рендер — заметная работа на слабом
// WebView.
//
// Переписываются только медиа-атрибуты. href не трогаем: абсолютная ссылка
// на SPA-маршрут увела бы WebView нативного приложения из бандла на сайт.
//
// srcset обязателен наравне с src: браузер предпочитает его кандидатов,
// и абсолютизированный src в одиночку картинку не чинит.
//
// Перед именем атрибута — пробельный символ, а не \b: граница слова матчила
// бы и data-src ленивых загрузчиков (дефис — тоже граница слова).
const SRC_ATTR = /(\s(?:src|poster)\s*=\s*)(["'])(\/(?!\/)[^"']*)\2/gi
const SRCSET_ATTR = /(\ssrcset\s*=\s*)(["'])([^"']*)\2/gi

export function absolutizeHtml(html) {
  if (typeof html !== 'string' || !html) return html
  return html
    .replace(SRC_ATTR, (match, attr, q, path) =>
      isBundled(path) ? match : `${attr}${q}${SERVER}${path}${q}`)
    .replace(SRCSET_ATTR, (match, attr, q, value) => {
      const rewritten = value.split(',').map(part => {
        const candidate = part.trim()
        const [url, ...descriptor] = candidate.split(/\s+/)
        if (!url || !url.startsWith('/') || url.startsWith('//') || isBundled(url)) return candidate
        return [SERVER + url, ...descriptor].join(' ')
      }).join(', ')
      return `${attr}${q}${rewritten}${q}`
    })
}
